import Hero from "../components/Hero";
import FranchiseBanner from "../components/FranchiseBanner";
import Marquee from "../components/Marquee";
import BrandStory from "../components/BrandStory";
import Products from "../components/Products";
import CoffeeExperience from "../components/CoffeeExperience";
import WhyTMV from "../components/WhyTMV";
import DealerSection from "../components/DealerSection";
import InstagramSection from "../components/InstagramSection";
import Testimonials from "../components/Testimonials";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { scrollToHash } from "../config/site";

const Home = () => {
  const { hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const t = setTimeout(() => scrollToHash(hash), 400);
      return () => clearTimeout(t);
    }
  }, [hash]);

  return (
    <main data-testid="home-page">
      <Hero />
      <FranchiseBanner />
      <Marquee />
      <BrandStory />
      <Products />
      <CoffeeExperience />
      <WhyTMV />
      <DealerSection />
      <InstagramSection />
      <Testimonials />
    </main>
  );
};

export default Home;
